import CountriesService from '../../services/countries.service.js';
import i18n from '../../i18n.js';

export const state = {
  countries: [],
  languages: [],
  extendedLanguages: []
};

export const mutations = {
  SET_COUNTRIES(state, countries) {
    state.countries = countries;
  },
  SET_LANGUAGES(state, languages) {
    state.languages = languages;
  },
  SET_EXTENDED_LANGUAGES(state, extendedLanguages) {
    state.extendedLanguages = extendedLanguages;
  }
};
export const getters = {
  getTimezones: (state) => {
    return (countryCca3) => {
      if (!countryCca3) {
        return [];
      }
      const countryInfo = state.countries.find((country) => country.key === countryCca3);
      if (!countryInfo) {
        return [];
      }
      return countryInfo.timezones.map((timezone) => {
        return { key: timezone, value: timezone };
      });
    };
  },
  getLanguages: (state) => {
    let langs = [];
    if (i18n.availableLocales.length) {
      langs = state.languages.map((lang) => {
        return { key: lang.key, value: i18n.t(lang.value) };
      });
    }
    return langs;
  },
  getExtendedLanguages: (state) => {
    let langs = [];
    if (i18n.availableLocales.length) {
      langs = state.extendedLanguages.map((lang) => {
        return { key: lang.key, value: i18n.t(lang.value) };
      });
    }
    return langs;
  }
};

export const actions = {
  fetchCountries({ commit, rootGetters }) {
    try {
      const lang = rootGetters.lang;
      const countries = CountriesService.fetchCountries(lang);
      commit('SET_COUNTRIES', countries);
    } catch (err) {
      console.error(err);
    }
  },
  fetchLanguages({ commit }) {
    try {
      const languages = CountriesService.fetchLanguages();
      commit('SET_LANGUAGES', languages);
    } catch (err) {
      console.error(err);
    }
  },
  fetchExtendedLanguages({ commit }) {
    try {
      const languages = CountriesService.fetchExtendedLanguages();
      commit('SET_EXTENDED_LANGUAGES', languages);
    } catch (err) {
      console.error(err);
    }
  }
};
